import React, { Fragment, useEffect, useMemo, useState } from "react";
import DataTable from "./DataTable";
import EmployeeVisibleColumn from "./EmployeeVisibleColumn";
import ErrorBoundary from "../../ErrorBoundry";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { faDiagramProject, faTrash } from "@fortawesome/pro-duotone-svg-icons";
import { Container, Row } from "reactstrap";
import { Grid } from "@mui/material";
import Header from "./Header";

const AssignedEmployeeByRole = ({
  isLoading,
  deleteResult,
  deleteLTD,
  EmployeeNo,
  ...props
}) => {
  const history = useNavigate();
  const params = useParams();
  const [deleteData, setDeleteData] = useState(null);
  const location = useLocation();
  const path = location.pathname.toLowerCase().includes("supervisor")
    ? "Supervisor"
    : "Timekeeper";

  useEffect(() => {
    if (
      deleteResult != undefined &&
      !!Object.keys(deleteResult).length &&
      !isLoading
    ) {
      setDeleteData({ dt: new Date() });
    }
  }, [deleteResult, isLoading]);

  return (
    <ErrorBoundary>
      <Fragment>
        <Container fluid={true}>
          <Row>
            <Header title={"Supervisor Assignment"} url={"payroll-employees"} />
          </Row>
        </Container>
      </Fragment>
      <DataTable
        tableName={"vw_EmployeeListingToAddUnderSupervision_V2"}
        visibleColumns={EmployeeVisibleColumn}
        title={`Assign Employees - ${params?.superVisorId}`}
        sort={[{ field: "EmployeeNo", dir: "asc" }]}
        deleteData={deleteData}
        setDeleteData={setDeleteData}
        isLoading={isLoading}
        additionalWheres={params?.superVisorId ? ` (SupervisorIds is null or SupervisorIds not like '%${params?.superVisorId}%') AND EmployeeNo != ${params?.superVisorId}` : ''}
        isDashboard={false}
        isEmployeeManagement={false}
        actions={[]}
        checkboxAction={true}
        checkboxKey={"EmployeeNo"}
        isAssignEmployee={true}
        supervisorId={params?.superVisorId}
        supervisorRole={path}
      />
    </ErrorBoundary>
  );
};

export default AssignedEmployeeByRole;
